import React, { useEffect, useState, useContext, createContext } from "react";
import { Layout, notification, Transfer, Modal } from "antd";
import { observer } from "mobx-react-lite";
import MaterialStore from "../store/materialstore";
import { MaterialList } from "./MaterialList";
import { MaterialGrid } from "./MaterialGrid";

import { UploadWizardBaseView } from "./UploadWizardBaseView";
import { MQuery } from "./MQuery";
const { Content, Sider } = Layout;
const materialStoreCtx = createContext(MaterialStore);
export const MaterialUsageBaseView = () => {
  const materialStore = useContext(materialStoreCtx);
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: `2px solid ${
          materialStore.mainStore.assetContextId === 2
            ? "rgb(242, 156, 31)"
            : "rgb(47, 168, 204)"
        }`,
      }}
    >
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={400}
            style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <MaterialList />
                </div>
              </div>
            </div>
          </Sider>
          <Content>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <MaterialGrid />
                  <UploadWizardBaseView />
                  <MQuery />
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

